import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function GoogleSearchImageIcon(props) {
    return (
        <SvgIcon {...props}>
            <svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'
                 viewBox='0 0 368 368' xmlSpace='preserve'>
                <g transform='translate(22 26)'>
                    <path fill='#ADE3E6' d='M306,14c17.6,0,32,14.4,32,32v224c0,17.6-14.4,32-32,32H18c-17.6,0-32-14.4-32-32V46
		c0-17.6,14.4-32,32-32H306L306,14z' />
                    <path fill='#08AAB4'
                          d='M334,178.8l-47.6-47.6c-3.2-3.2-8-3.2-11.2,0l-96.8,95.2l-60-56.4L-0.8,296.8h336L334,178.8z' />
                    <path fill='#5AC6CD' d='M177.2,222.8l-52.4-50.4c-3.2-3.2-8-3.2-11.2,0L-10,294h120L177.2,222.8z' />
                    <g>
                        <path fill='#0D797F' d='M132,278c-2,0-4-0.8-5.6-2.4c-3.2-3.2-3.2-8,0-11.2l8-8c3.2-3.2,8-3.2,11.2,0c3.2,3.2,3.2,8,0,11.2
			l-8,8C136,277.2,134,278,132,278z' />
                        <path fill='#0D797F' d='M-1.2,293.2c-2,0-4-0.8-5.6-2.4c-3.2-3.2-3.2-8.4,0-11.2L108.8,166c3.2-3.2,7.2-4.8,11.2-4.8
			s8.4,1.6,11.2,4.8l46.4,46.4c3.2,3.2,3.2,8,0,11.2s-8,3.2-11.2,0L120,177.2L4.4,290.8C2.8,292.4,0.8,293.2-1.2,293.2z' />
                    </g>
                    <path fill='#5F971D' d='M156.8,252.8c-2,0-4-0.8-5.6-2.4c-3.2-3.2-3.2-8,0-11.2l118.4-117.6c6.4-6.4,16-6.4,22.4,0
		l47.6,47.6c3.2,3.2,3.2,8,0,11.2s-8,3.2-11.2,0l-47.6-47.6L162.4,250.4C160.8,252,158.8,252.8,156.8,252.8z' />
                    <path fill='#62A2DD' d='M306,310H18c-22,0-40-18-40-40V46C-22,24-4,6,18,6h288c22,0,40,18,40,40v224
		C346,292,328,310,306,310z M18,22C4.8,22-6,32.8-6,46v224c0,13.2,10.8,24,24,24h288c13.2,0,24-10.8,24-24V46c0-13.2-10.8-24-24-24
		H18z' />
                    <circle fill='#F9A237' cx='66' cy='94' r='24' />
                    <path fill='#F9A237' d='M66,118c13.2,0,24-10.8,24-24S79.2,70,66,70C66,94,66,99.6,66,118z' />
                    <path fill='#F35325' d='M66,126c-17.6,0-32-14.4-32-32s14.4-32,32-32s32,14.4,32,32S83.6,126,66,126z M66,78
		c-8.8,0-16,7.2-16,16s7.2,16,16,16s16-7.2,16-16S74.8,78,66,78z' />
                    <g transform='translate(108, 90) scale(0.468)'>
                        <circle fill='#FFFFFF' cx='256' cy='256' r='266' opacity='0.8' />
                        <path
                            fill='#fbbb00'
                            d='M113.47,309.408L95.648,375.94l-65.139,1.378C11.042,341.211,0,299.9,0,256
	c0-42.451,10.324-82.483,28.624-117.732h0.014l57.992,10.632l25.404,57.644c-5.317,15.501-8.215,32.141-8.215,49.456
	C103.821,274.792,107.225,292.797,113.47,309.408z'
                        />
                        <path
                            fill='#518ef8'
                            d='M507.527,208.176C510.467,223.662,512,239.655,512,256c0,18.328-1.927,36.206-5.598,53.451
	c-12.462,58.683-45.025,109.925-90.134,146.187l-0.014-0.014l-73.044-3.727l-10.338-64.535
	c29.932-17.554,53.324-45.025,65.646-77.911h-136.89V208.176h138.887L507.527,208.176L507.527,208.176z'
                        />
                        <path
                            fill='#28b446'
                            d='M416.253,455.624l0.014,0.014C372.396,490.901,316.666,512,256,512
	c-97.491,0-182.252-54.491-225.491-134.681l82.961-67.91c21.619,57.698,77.278,98.771,142.53,98.771
	c28.047,0,54.323-7.582,76.87-20.818L416.253,455.624z'
                        />
                        <path
                            fill='#f14336'
                            d='M419.404,58.936l-82.933,67.896c-23.335-14.586-50.919-23.012-80.471-23.012
	c-66.729,0-123.429,42.957-143.965,102.724l-83.397-68.276h-0.014C71.23,56.123,157.06,0,256,0
	C318.115,0,375.068,22.126,419.404,58.936z'
                        />
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}
